import { Box } from '@mantine/core';
import { PublishedModel } from '../../interfaces/api';
import Image from 'next/image';

export function Thumbnail({ model }: { model: PublishedModel }) {
  return (
    <>
      {model?.thumbnail ? (
        <Image src={model.thumbnail} alt={model.name} width={84} height={84} style={{ height: 'auto' }} />
      ) : (
        <Box w={84} h={84} />
      )}
    </>
  );
}
